/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../utils/SkeletonSettings";
import {RecipeListRowSkeleton} from "./RecipeListRowSkeleton";

export const RecipeListSectionSkeleton = (props) => {
    return <><ContentLoader
        height={50}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: "3px solid #dcdcdc"}}
        {...props}>

        {/* Section Title */}
        <rect x="0" y="12" rx="3" ry="3" width="30%" height="35"/>

    </ContentLoader>

        {[...Array(4)].map((item, i) => <RecipeListRowSkeleton/>)}</>
}
